module.exports = __webpack_public_path__ + "static/media/ka.c5b1cb1c.png";